import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ViewChild,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AlertService } from "src/app/_core/_services/alert.service";
import { CampaignsService } from "src/app/_core/_services/campaigns/campaigns.service";
import { TranslateService } from "@ngx-translate/core";
import { AddTagModalComponent } from "src/app/_metronic/layout/components/modals/add-tags-modal/add-tag-modal/add-tag-modal.component";
import { TagsService } from "src/app/_core/_services/tags/tags.service";
import { PromptCloneService } from "src/app/_core/_services/prompt-clone/prompt-clone.service";

interface CampaignPromptData {
  company: string;
  name: string;
  language: string;
  entry_settings: string;
  extra_settings: string;
  hangup_setence: string;
  faq: { question: string; answer: string; tags: Tag[] }[];
  steps: { step: string }[];
}

interface Tag {
  id: number;
  value: string;
  color: string;
}

@Component({
  selector: "app-edit-prompt-modal",
  templateUrl: "./edit-prompt-modal.component.html",
  styleUrls: ["./edit-prompt-modal.component.scss"],
})
export class EditPromptModalComponent implements OnInit {
  @Input() publicCampaign!: string;
  @Input() isReopened = false;

  @Output() saveAndReopen = new EventEmitter<{ [key: string]: boolean }>();

  @ViewChild("form", { static: true }) form!: NgForm;
  @ViewChild("faqList") faqList!: ElementRef;
  @ViewChild("taskList") taskList!: ElementRef;

//   showContextMenu: boolean = false;
// contextMenuPosition = { x: 0, y: 0 };
// selectedIndex: number | null = null;


  availableTags: Tag[] = [];
  hasUnsavedChanges = false;

  clonedPromptData: CampaignPromptData | null = null;
  clonedPromptAvailable = false;
  isPasted = false;

  currentStep = 1;
  isLoading = false;
  formData: CampaignPromptData = this.resetFormData();
  reopenModalAfterSave = false;
  showSuccessMessage = true;
  modifiedFields: { [key: string]: boolean } = {};
  hangupSentences: string[] = [];

  steps: { title: string; description: string }[] = [];

  characterCounts: { [key: string]: number } = {
    company: 0,
    name: 0,
    language: 0,
    entry_settings: 0,
    extra_settings: 0,
    hangup_setence: 0,
  };

  constructor(
    public activeModal: NgbActiveModal,
    private campaignPromptService: CampaignsService,
    private promptCloneService: PromptCloneService,
    private alertService: AlertService,
    private tagsService: TagsService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.clonedPromptAvailable = this.promptCloneService.hasClonedPromptData();
   // alert('clonedPromptAvailable '+this.clonedPromptAvailable)
    this.initializeStepTitles();
    this.loadAvailableTags();
    if (this.publicCampaign) {
      this.loadCampaignPrompt();
    }

    this.updateHangupSentences();
    this.initializeCharacterCounts();
    this.cdr.detectChanges();
  }

  drop(event: CdkDragDrop<any[]>): void {
    // Deep copy the array to preserve original values
    const stepsCopy = JSON.parse(JSON.stringify(this.formData.steps));
  
    // Perform the reorder operation
    const [movedItem] = stepsCopy.splice(event.previousIndex, 1); // Remove the dragged item
    stepsCopy.splice(event.currentIndex, 0, movedItem); // Insert it at the new index
  
    // Reassign the reordered array back to formData
    this.formData.steps = stepsCopy;
  
    // Mark as unsaved changes
    this.hasUnsavedChanges = true;
  
    // Update task order
    this.updateTaskOrder();
  }

  
  // deleteStepItem(index: number): void {
  //   if (index >= 0 && index < this.formData.steps.length) {
  //     this.formData.steps.splice(index, 1); // Remove the task
  //     this.trackFieldChange('steps'); // Track changes
  //     console.log(`Task at index ${index} has been removed.`);
  //   }
  // }
  
  
  


  /**
   * Updates task order and notifies the form of changes.
   */
  updateTaskOrder(): void {
    // Update modifiedFields for reordered tasks if necessary
    this.formData.steps.forEach((step, index) => {
      this.trackFieldChange(`step-${index}`);
    });
    this.cdr.detectChanges();
  }

  
  
  

  updateHangupSentences(): void {
    const language = this.formData.language;
    console.log('language!!!!!!!!!!!!!!!!!! ',language)

    switch (language) {
      case "Polish":
        this.hangupSentences = ["do widzenia"];
        break;
      case "German":
        this.hangupSentences = ["auf wiedersehen", "auf wiederhören"];
        break;
      case "English":
        this.hangupSentences = ["goodbye"];
        break;
      default:
        this.hangupSentences = ["goodbye"];
        break;
    }

    if (!this.hangupSentences.includes(this.formData.hangup_setence)) {
      this.formData.hangup_setence = this.hangupSentences[0];
    }
  }

  initializeCharacterCounts(): void {
    // Iterate through the characterCounts keys and calculate their lengths from formData
    for (const field of Object.keys(this.characterCounts)) {
      const value = (this.formData as any)[field]; // Access the corresponding value in formData
      this.characterCounts[field] = value ? value.length : 0;
    }
  }

  getTagInitial(tag: Tag | undefined): string {
    if (tag?.value) {
      return tag.value.charAt(0).toUpperCase();
    }
    return "+";
  }

  ngOnDestroy(): void {
    if (this.form.dirty || this.hasUnsavedChanges) {
      this.showUnsavedChangesAlert();
    }
  }

  loadAvailableTags(forceRefresh: boolean = false): void {
    if (forceRefresh || !this.availableTags.length) {
      this.tagsService
        .getAvailableTags(this.publicCampaign, forceRefresh)
        .subscribe(
          (tags: Tag[]) => {
            this.availableTags = tags;
          },
          (error) => {
            console.error("Error fetching available tags:", error);
          }
        );
    }
  }

  initializeStepTitles() {
    this.steps = [
      {
        title: this.translate.instant("EDIT_PROMPT.STEP_DETAILS_TITLE"),
        description: this.translate.instant(
          "EDIT_PROMPT.STEP_DETAILS_DESCRIPTION"
        ),
      },
      {
        title: this.translate.instant("EDIT_PROMPT.STEP_SETTINGS_TITLE"),
        description: this.translate.instant(
          "EDIT_PROMPT.STEP_SETTINGS_DESCRIPTION"
        ),
      },
      {
        title: this.translate.instant("EDIT_PROMPT.STEP_EXTRA_SETTINGS_TITLE"),
        description: this.translate.instant(
          "EDIT_PROMPT.STEP_EXTRA_SETTINGS_DESCRIPTION"
        ),
      },
      {
        title: this.translate.instant("EDIT_PROMPT.STEP_TASKS_TITLE"),
        description: this.translate.instant(
          "EDIT_PROMPT.STEP_TASKS_DESCRIPTION"
        ),
      },
      {
        title: this.translate.instant("EDIT_PROMPT.STEP_FAQ_TITLE"),
        description: this.translate.instant("EDIT_PROMPT.STEP_FAQ_DESCRIPTION"),
      },
    ];
  }

  resetFormData(): CampaignPromptData {
    return {
      company: "",
      name: "",
      language: "",
      entry_settings: "",
      extra_settings: "",
      hangup_setence: "",
      faq: [{ question: "", answer: "", tags: [] }],
      steps: [{ step: "" }],
    };
  }

  loadCampaignPrompt(): void {
    this.isLoading = true;
    this.campaignPromptService.getCampaignPrompt(this.publicCampaign).subscribe(
      (response) => {
        if (response && response.length) {
          const promptData = response[0].prompt;

          promptData.faq.forEach((faqItem: any) => {
            faqItem.tags = faqItem.tags || [];
          });

          Object.assign(this.formData, promptData);

          this.initializeCharacterCounts();
          this.updateHangupSentences();
        } else {
          console.warn("No data found in response");
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        console.error("Error loading campaign prompt:", error);
        this.isLoading = false;
      }
    );
  }

  setStep(step: number) {
    if (step >= 1 && step <= this.steps.length) {
      this.currentStep = step;
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  nextStep() {
    if (this.currentStep < this.steps.length) {
      this.currentStep++;
    }
  }

  addFaqItem(): void {
    this.formData.faq.push({ question: "", answer: "", tags: [] });

    // Scroll to the bottom to show the newly added FAQ item
    setTimeout(() => {
      if (this.faqList) {
        const element = this.faqList.nativeElement;
        element.scrollTop = element.scrollHeight;
      }
    }, 0); // Ensure DOM is updated before scrolling
  }

  removeFaqItem(index: number): void {
    if (this.formData.faq.length > 0) {
      // Remove the FAQ item and associated tags
      const removedFaq = this.formData.faq.splice(index, 1)[0];

      // Optional: Perform any cleanup for tags, if needed
      if (removedFaq?.tags && removedFaq.tags.length > 0) {
        console.log(
          `Tags removed with FAQ at index ${index}:`,
          removedFaq.tags
        );
        // Example: Perform additional cleanup for tags if required
      }

      // Optional: Adjust scroll position if needed after removal
      setTimeout(() => {
        if (this.faqList) {
          const element = this.faqList.nativeElement;
          element.scrollTop = element.scrollHeight;
        }
      }, 0);

      this.hasUnsavedChanges = true; // Track unsaved changes
    }
  }

  addStepItem(): void {
    this.formData.steps.push({ step: "" });

    // Scroll to the bottom to show the newly added step item
    setTimeout(() => {
      if (this.taskList) {
        const element = this.taskList.nativeElement;
        element.scrollTop = element.scrollHeight;
      }
    }, 0); // Ensure DOM is updated before scrolling
  }

  removeStepItem(index: number): void {
    if (this.formData.steps.length > 1) {
      this.formData.steps.splice(index, 1);

      // Optional: Adjust scroll position if needed after removal
      setTimeout(() => {
        if (this.taskList) {
          const element = this.taskList.nativeElement;
          element.scrollTop = element.scrollHeight;
        }
      }, 0);
    }
  }

  onSubmit() {
    this.showSuccessMessage = true;

    // Filter out only incomplete FAQ entries but allow the FAQ section to remain empty
    this.formData.faq = this.formData.faq.filter(
      (faq) => faq.question.trim() !== "" || faq.answer.trim() !== ""
    );

    // Filter out empty steps
    this.formData.steps = this.formData.steps.filter(
      (step) => step.step.trim() !== ""
    );
    
    this.saveData();
    this.isPasted = false;
    this.clonedPromptAvailable = false;
    this.promptCloneService.clearClonedPromptData();
    this.cdr.detectChanges();
  }

  filterEmptyEntries() {
    // Filter steps to remove empty entries
    this.formData.steps = this.formData.steps.filter(
      (step) => step.step.trim() !== ""
    );

    // Allow an empty FAQ section but filter out incomplete entries
    this.formData.faq = this.formData.faq.filter(
      (faq) => faq.question.trim() !== "" || faq.answer.trim() !== ""
    );
  }

  saveData(): void {
    this.campaignPromptService
      .updateCampaignPrompt(this.publicCampaign, this.formData)
      .subscribe(
        (response) => {
          console.log('savedata!!!!!!!!!!! ',this.isPasted)
          this.form.resetForm(this.formData);
          this.hasUnsavedChanges = false;
          this.isPasted = false; 
          this.clonedPromptAvailable = false;
          this.promptCloneService.clearClonedPromptData();
          this.modifiedFields = {};
          if (this.showSuccessMessage) {
            this.translate
              .get("EDIT_PROMPT.SAVE_SUCCESS")
              .subscribe((res: string) => {
                this.alertService.success(res);
              });
          }

          if (this.reopenModalAfterSave) {
            this.reopenModalAfterSave = false;
            this.isReopened = true;
            this.saveAndReopen.emit(this.modifiedFields);
            this.activeModal.close();
          } else {
            this.activeModal.close(this.formData);
          }
        },
        (error) => {
          this.translate
            .get("EDIT_PROMPT.SAVE_ERROR")
            .subscribe((res: string) => {
              this.alertService.error(res);
            });
        }
      );
  }

  openTagModal(faqIndex: number): void {
    const modalRef = this.modalService.open(AddTagModalComponent, {
      size: "md",
      backdrop: "static",
    });
    modalRef.componentInstance.publicId = this.publicCampaign;
    modalRef.componentInstance.selectedTags = [
      ...this.formData.faq[faqIndex].tags,
    ];

    modalRef.componentInstance.tagSelected.subscribe((selectedTags: Tag[]) => {
      // Restrict to one tag
      if (selectedTags.length > 0) {
        this.formData.faq[faqIndex].tags = [selectedTags[0]]; // Keep only the first selected tag
        this.hasUnsavedChanges = true; // Track unsaved changes
        this.trackFieldChange(`faq-tags-${faqIndex}`);
      }
    });
  }

  removeTag(faqIndex: number, tagId: number): void {
    // Ensure the FAQ item exists and has a tags array
    const faqItem = this.formData.faq[faqIndex];
    if (!faqItem || !faqItem.tags || faqItem.tags.length === 0) {
      console.warn(
        `FAQ item at index ${faqIndex} does not exist or has no tags.`
      );
      return;
    }

    const initialLength = faqItem.tags.length;

    // Filter out the tag with the specified ID
    faqItem.tags = faqItem.tags.filter((tag) => tag.id !== tagId);

    // Check if any tags were removed
    if (faqItem.tags.length !== initialLength) {
      this.hasUnsavedChanges = true; // Mark unsaved changes
      this.trackFieldChange(`faq-tags-${faqIndex}`);
      console.log(`Tag with ID ${tagId} removed from FAQ index ${faqIndex}.`);
    } else {
      console.log(`Tag with ID ${tagId} not found in FAQ index ${faqIndex}.`);
    }
  }

  onExportTasks(): void {
    const csvRows = [];
  
    // Handle case where no tasks exist
    if (this.formData.steps.length === 0) {
      alert("No tasks to export.");
      return;
    }
  
    // Filter valid tasks
    const validTasks = this.formData.steps.filter((step) => step.step.trim() !== "");
  
    if (validTasks.length === 0) {
      alert("No valid tasks to export.");
      return;
    }
  
    // Header row
    const headerRow = ["Task"];
    csvRows.push(headerRow.join(";"));
  
    // Add tasks as rows
    validTasks.forEach((stepItem) => {
      const task = stepItem.step.replace(/"/g, '""'); // Escape double quotes
      const wrappedTask = task.includes("\n") ? `"${task}"` : task; // Wrap multi-line tasks in quotes
      csvRows.push(wrappedTask);
    });
  
    const csvContent = "\uFEFF" + csvRows.join("\n");
  
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "tasks_export.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  
  
  

  onExport(): void {
    const csvRows = [];

    // Handle case where FAQ is empty
    if (this.formData.faq.length === 0) {
      alert("No FAQs to export.");
      return;
    }

    // Filter valid FAQs
    const validFaqs = this.formData.faq.filter(
      (faq) => faq.question.trim() !== "" || faq.answer.trim() !== ""
    );

    if (validFaqs.length === 0) {
      alert("No valid FAQs to export.");
      return;
    }

    // Create the header row dynamically based on the maximum number of tags
    const maxTags = Math.max(...validFaqs.map((faq) => faq.tags.length), 0);
    const headerRow = [
      "Question",
      "Answer",
      ...Array.from({ length: maxTags }, (_, i) => `Tag${i + 1}`),
    ];
    csvRows.push(headerRow.join(";"));

    // Function to escape fields only when necessary
    const escapeCsvField = (field: string): string => {
      if (/["\n;]/.test(field)) {
        return `"${field.replace(/"/g, '""')}"`; // Escape internal quotes
      }
      return field; // Return the field as-is if no escaping is needed
    };

    // Create rows for each valid FAQ
    validFaqs.forEach((faq) => {
      const row = [
        escapeCsvField(faq.question),
        escapeCsvField(faq.answer),
        ...faq.tags.map((tag) => tag.id.toString()),
      ];

      // Pad rows with fewer tags to match the header
      while (row.length < headerRow.length) {
        row.push("");
      }

      csvRows.push(row.join(";"));
    });

    const csvContent = "\uFEFF" + csvRows.join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "faq_export.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  handleFileInput(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const csvContent = e.target.result;
      this.processCsvContent(csvContent);
      this.resetFileInput(event.target); // Clear the input after processing
    };
    reader.readAsText(file);
  }

  resetFileInput(fileInput: HTMLInputElement): void {
    fileInput.value = ""; // Reset the value to allow selecting the same file again
  }
  

  private isEmptyRow(row: string): boolean {
    return row.split(",").every((col) => !col.trim());
  }

  private cleanCsvField(field: string): string {
    if (field.startsWith('"') && field.endsWith('"')) {
      return field.slice(1, -1).replace(/""/g, '"');
    }
    return field;
  }

  processCsvContent(csvContent: string): void {
    this.translate
      .get([
        "CSV_IMPORT.INVALID_STRUCTURE",
        "CSV_IMPORT.IMPORT_FAQS_TITLE",
        "CSV_IMPORT.IMPORT_FAQS_TEXT",
        "CSV_IMPORT.OVERWRITE_SUCCESS",
        "CSV_IMPORT.ADD_SUCCESS",
        "CSV_IMPORT.DUPLICATES_FOUND",
        "ALERT.INFO",
      ])
      .subscribe((translations) => {
        console.log("Starting CSV import...");
        const rows = csvContent
          .split("\n")
          .map((row) => row.trim())
          .filter((row) => row);

        console.log("Rows:", rows);

        const headers = rows
          .shift()
          ?.split(";")
          .map((header) => header.trim());
        console.log("Headers:", headers);

        if (
          !headers ||
          !headers.includes("Question") ||
          !headers.includes("Answer")
        ) {
          this.alertService.error(translations["CSV_IMPORT.INVALID_STRUCTURE"]);
          return;
        }

        const tagColumns = headers.filter((header) => header.startsWith("Tag"));
        console.log("Tag columns:", tagColumns);

        const importedFaqs: { [key: string]: { answer: string; tags: Tag[] } } =
          {};

        rows.forEach((row, index) => {
          console.log(`Processing row ${index + 1}:`, row);

          const columns =
            row.match(/(?:\".*?\"|[^;]+)(?=\s*;|\s*$)/g)?.map((col) =>
              col
                .trim()
                .replace(/(^"|"$)/g, "")
                .replace(/""/g, '"')
            ) || [];
          console.log(`Columns for row ${index + 1}:`, columns);

          if (columns.length < 2) {
            console.warn("Row skipped due to invalid column structure:", row);
            return;
          }

          const rawQuestion = columns[headers.indexOf("Question")] || "";
          const rawAnswer = columns[headers.indexOf("Answer")] || "";

          console.log(`Raw Question: ${rawQuestion}, Raw Answer: ${rawAnswer}`);

          const tagIds = tagColumns
            .map((tagColumn) => {
              const index = headers.indexOf(tagColumn);
              return columns[index]?.trim();
            })
            .filter((tagId) => tagId);

          console.log(`Tag IDs for row ${index + 1}:`, tagIds);

          const matchedTags = tagIds
            .map((tagId) => {
              const matchedTag = this.availableTags.find(
                (t) => t.id.toString() === tagId
              );
              if (matchedTag) {
                return {
                  id: matchedTag.id,
                  value: matchedTag.value,
                  color: matchedTag.color,
                };
              }
              console.warn(
                `Tag ID "${tagId}" is not valid for this campaign and will be skipped.`
              );
              return null;
            })
            .filter((tag): tag is Tag => tag !== null);

          console.log(`Matched Tags for row ${index + 1}:`, matchedTags);

          if (!importedFaqs[rawQuestion]) {
            importedFaqs[rawQuestion] = {
              answer: rawAnswer,
              tags: matchedTags,
            };
          } else {
            const existingTags = importedFaqs[rawQuestion].tags;
            importedFaqs[rawQuestion].tags = [
              ...existingTags,
              ...matchedTags.filter(
                (newTag) => !existingTags.some((tag) => tag.id === newTag.id)
              ),
            ];
          }
        });

        const consolidatedFaqs = Object.entries(importedFaqs).map(
          ([question, { answer, tags }]) => ({
            question,
            answer,
            tags,
          })
        );

        console.log("Consolidated FAQs:", consolidatedFaqs);

        this.alertService.confirmOverwriteOrAdd(
          translations["CSV_IMPORT.IMPORT_FAQS_TITLE"],
          translations["CSV_IMPORT.IMPORT_FAQS_TEXT"],
          () => {
            console.log("User chose to overwrite.");
            const totalAdded = consolidatedFaqs.length;
            this.formData.faq = consolidatedFaqs;
            this.trackFieldChange("faq"); // Track changes
            this.showUnsavedChangesAlert(); // Show unsaved changes alert
            this.alertService.success(
              translations["CSV_IMPORT.OVERWRITE_SUCCESS"].replace(
                "{count}",
                totalAdded.toString()
              )
            );
          },
          () => {
            console.log("User chose to append only new FAQs.");
            const duplicates: {
              question: string;
              answer: string;
              tags: Tag[];
            }[] = [];
            let addedCount = 0;

            consolidatedFaqs.forEach((faq) => {
              const isDuplicate = this.formData.faq.some((existingFaq) => {
                const isSameQuestion = existingFaq.question === faq.question;
                const isSameAnswer = existingFaq.answer === faq.answer;
                const existingTagIds = existingFaq.tags
                  .map((tag) => tag.id)
                  .sort();
                const newTagIds = faq.tags.map((tag) => tag.id).sort();
                const areTagsSame =
                  JSON.stringify(existingTagIds) === JSON.stringify(newTagIds);
                return isSameQuestion && isSameAnswer && areTagsSame;
              });

              if (isDuplicate) {
                duplicates.push(faq);
              } else {
                this.formData.faq.push(faq);
                addedCount++;
              }
            });

            this.trackFieldChange("faq"); // Track changes
            this.showUnsavedChangesAlert(); // Show unsaved changes alert

            if (duplicates.length > 0) {
              this.alertService.warning(
                translations["CSV_IMPORT.DUPLICATES_FOUND"].replace(
                  "{count}",
                  duplicates.length.toString()
                )
              );
            }

            if (addedCount > 0) {
              this.alertService.success(
                translations["CSV_IMPORT.ADD_SUCCESS"]
                  .replace("{addedCount}", addedCount.toString())
                  .replace("{duplicateCount}", duplicates.length.toString())
              );
            } else if (duplicates.length > 0) {
              this.alertService.info(
                translations["CSV_IMPORT.DUPLICATES_FOUND"].replace(
                  "{count}",
                  duplicates.length.toString()
                )
              );
            }
          }
        );
      });
    this.hasUnsavedChanges = true;
  }

  handleFileInputTasks(event: any): void {
    const file = event.target.files[0];
    if (!file) return;
  
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const csvContent = e.target.result;
      this.processCsvContentTasks(csvContent);
      this.resetFileInput(event.target); // Clear the input after processing
    };
    reader.readAsText(file);
  }
  
  processCsvContentTasks(csvContent: string): void {
    const rows = csvContent.split("\n"); // Split by line
    const tasks = [];
    let currentTask = "";
  
    // Skip the first row (header)
    const dataRows = rows.slice(1);
  
    dataRows.forEach((row) => {
      const trimmedRow = row.trim();
  
      if (trimmedRow.startsWith('"') && trimmedRow.endsWith('"')) {
        // Row is a single-line quoted task
        tasks.push(trimmedRow.slice(1, -1).replace(/""/g, '"')); // Remove quotes and unescape double quotes
      } else if (trimmedRow.startsWith('"')) {
        // Row starts a multi-line quoted task
        currentTask = trimmedRow.slice(1); // Start accumulating
      } else if (trimmedRow.endsWith('"')) {
        // Row ends a multi-line quoted task
        currentTask += "\n" + trimmedRow.slice(0, -1); // Add to current task and remove ending quote
        tasks.push(currentTask.replace(/""/g, '"')); // Unescape double quotes
        currentTask = ""; // Reset current task
      } else if (currentTask) {
        // Row is part of a multi-line quoted task
        currentTask += "\n" + trimmedRow; // Accumulate
      } else if (trimmedRow) {
        // Row is an unquoted single-line task
        tasks.push(trimmedRow);
      }
    });
  
    if (currentTask) {
      // Add the last accumulated task if it exists
      tasks.push(currentTask.replace(/""/g, '"'));
    }
  
    const importedTasks = tasks.map((task) => ({ step: task }));
  
    // Confirm overwrite or append
    this.alertService.confirmOverwriteOrAdd(
      this.translate.instant("CSV_IMPORT.IMPORT_TASKS_TITLE"),
      this.translate.instant("CSV_IMPORT.IMPORT_TASKS_TEXT"),
      () => {
        // Overwrite tasks
        this.formData.steps = importedTasks;
        this.trackFieldChange("steps");
        this.alertService.success(
          this.translate.instant("CSV_IMPORT.OVERWRITE_SUCCESS").replace("{count}", importedTasks.length.toString())
        );
      },
      () => {
        // Append new tasks
        const addedCount = importedTasks.filter((task) => {
          return !this.formData.steps.some((existingTask) => existingTask.step === task.step);
        }).length;
  
        this.formData.steps.push(...importedTasks);
        this.trackFieldChange("steps");
  
        if (addedCount > 0) {
          this.alertService.success(
            this.translate.instant("CSV_IMPORT.ADD_SUCCESS").replace("{addedCount}", addedCount.toString())
          );
        } else {
          this.alertService.info(
            this.translate.instant("CSV_IMPORT.DUPLICATES_FOUND").replace("{count}", "0")
          );
        }
      }
    );
  }
  
  
  
  
  

  

  validateImportedTags(importedFaqs: any[]): void {
    importedFaqs.forEach((faq) => {
      faq.tags.forEach((tag: { value: string }) => {
        const isValid = this.availableTags.some(
          (availableTag) => availableTag.value === tag.value
        );
        if (!isValid) {
          console.warn(
            `Tag "${tag.value}" is not valid for this campaign and will be removed.`
          );
          faq.tags = faq.tags.filter(
            (t: { value: any }) => t.value !== tag.value
          ); // Remove invalid tag
        }
      });
    });
  }

  getTagColor(tagValue: string): string {
    const tag = this.availableTags.find((t) => t.value === tagValue);
    return tag ? tag.color : "#000000"; // Default to black if tag is not found
  }

  get totalStepCharacters(): number {
    return this.formData.steps.reduce((total, stepItem) => {
      return total + (stepItem.step?.length || 0);
    }, 0);
  }

  get totalFaqCharacters(): number {
    return this.formData.faq.reduce((total, faqItem) => {
      const questionLength = faqItem.question?.length || 0;
      const answerLength = faqItem.answer?.length || 0;
      return total + questionLength + answerLength;
    }, 0);
  }

  get totalFaqQuestions(): number {
    return this.formData.faq.filter(
      (faqItem) => faqItem.question?.trim() !== ""
    ).length;
  }

  showUnsavedChangesAlert() {
    this.translate
      .get("EDIT_PROMPT.UNSAVED_CHANGES_ALERT")
      .subscribe((res: string) => {
        this.alertService.unsaved(
          () => {
            this.showSuccessMessage = false;
            this.reopenModalAfterSave = true;
            this.saveData(); // Save changes
          },
          () => {
            this.form.resetForm();
            this.formData = this.resetFormData();
            this.hasUnsavedChanges = false;
          }
        );
      });
  }

  trackFieldChange(field: string): void {
    this.modifiedFields[field] = true;
    const value = (this.formData as any)[field];
    this.characterCounts[field] = value ? value.length : 0;

    if (field === "language") {
      this.updateHangupSentences();
    }
  }

  clonePrompt(): void {
    this.campaignPromptService.getCampaignPrompt(this.publicCampaign).subscribe(
        (response) => {
            if (response && response.length) {
                const clonedData = response[0].prompt;
                this.promptCloneService.setClonedPromptData(clonedData);
                this.translate.get("EDIT_PROMPT.CLONE_SUCCESS").subscribe((message: string) => {
                    this.alertService.success(message);
                });
            } else {
                this.translate.get("EDIT_PROMPT.CLONE_FAIL").subscribe((message: string) => {
                    this.alertService.error(message);
                });
            }
        },
        (error) => {
            console.error("Error cloning prompt data:", error);
            this.translate.get("EDIT_PROMPT.CLONE_ERROR").subscribe((message: string) => {
                this.alertService.error(message);
            });
        }
    );

    // Do not emit a modal result
}


pastePrompt(): void {
  const clonedData = this.promptCloneService.getClonedPromptData();
  if (!clonedData) {
      this.translate.get("EDIT_PROMPT.NO_CLONED_DATA").subscribe((message: string) => {
          this.alertService.warning(message);
      });
      return;
  }

  // Populate the formData with the cloned data
  Object.assign(this.formData, clonedData);

  // Mark as modified and unsaved
  this.isPasted = true;
  this.hasUnsavedChanges = true;

  // Notify the user
  this.translate.get("EDIT_PROMPT.CLONED_DATA_PASTED").subscribe((message: string) => {
      this.alertService.success(message);
  });
}



  
  



  
  

  @HostListener("window:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
      return;
    }
    if (event.key === "ArrowRight") {
      this.nextStep();
    } else if (event.key === "ArrowLeft") {
      this.previousStep();
    }
  }
}
